<template>
	<div class="login-form">
		<h1 class="login-form__title">Login to your account</h1>
		<form class="form login-form__form" v-on:submit="logUserIn">
			<div class="form__message form__message--error" v-if="userUnknown">
				Sorry, the email address or username provided does not belong to an active account. You can <a class="link--styled" href="mailto:peter.nikashin@igt.com?subject=IGT Casino Lounge - Request Account">enquire about a new account here</a>.
			</div>
			<text-field class="login-form__email" label="Enter your email" type="text" name="email" placeholder="joe.bloggs@mail.com" v-model="username" />
			<text-field class="login-form__password" label="Password" type="password" name="password" placeholder="********"  v-model="password">
				<template slot="post-label">
						<router-link class="link--styled login-form__password-reset" tabindex="-1" :to="{ name: 'ResetPassword' }">
							<span class="fs--14">Forgot?</span>
 					</router-link>
 				</template>
			</text-field>
			<submit-field class="login-form__submit">
				<span>Login</span>
			</submit-field>
		</form>
	</div>
</template>

<script>
import TextField from '../atoms/TextField'
import SubmitField from '../atoms/SubmitField'

export default {
	name: 'LoginForm',
	components: {
		TextField,
		SubmitField,
	},
	data () {
		return {
			username: '',
			password: '',
			userUnknown: false
		}
	},
	created: function ()
	{
	},
	beforeRouteLeave (to, from, next)
	{
	},
	methods: {
		logUserIn(event)
		{
			var self = this;
			event.preventDefault();

			self.userUnknown = false;

			// Check if email address is valid. This could be a legacy account which
			// should show a different message to the usual "invalid email"
			const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (self.username !== '' && !emailRegex.test(self.username)) {
				self.userUnknown = true;
				return;
			}

			self.$api.login(self.username, self.password).then((success) =>
			{
				self.$root.getUser().then((success) =>
				{
					// Analytics
					self.trackEvent([
						'user-login',
						'success',
						self.$root.$data.user ? self.$root.$data.user.id : null,
						0,
						false
					]);

					// Hotjar
					if (process.env.NODE_ENV === "production" && typeof hj == 'function')
					{
						hj('trigger', 'logged_in');
					}

					// Broadcast
					this.$emit('success', success);
				})
				.catch((error) =>
				{
					this.$emit('error', error);
				});

			})
			.catch((error) =>
			{
				this.$emit('error', error);

				if(error.hasOwnProperty('code') && error.code === 404)
				{
					self.userUnknown = true;
				}
				else
				{
					var message = error.hasOwnProperty('message') ? 'Invalid email address or password' : 'An error occurred. We apologise for any inconvenience';
					self.$alert.danger({ message: message });
				}
			});
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".login-form";
	#{$c}
	{
		&__title
		{
			@include extend(h3);
			margin-bottom: rem(48);
			color: palette('grey');
		}

		&__email
		{
			margin-bottom: rem(24);
		}

		&__password
		{
			margin-bottom: rem(48);

			.field__label-wrap
			{
				display: flex;
				justify-content: space-between;
				align-items: center;
				align-content: center;
			}

			&-reset
			{
				@include css-variables
				{
					margin-bottom: calc( 1em * #{var(label-spacing)} / #{var(field-font-size)} );
				}
    	}
		}

		&__submit
		{
			text-align: center;

			.field__element
			{
				width: 100%;
				max-width: 216px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/molecules/LoginForm.vue